import React, { useEffect, useState } from 'react'
import {
  CBadge,
  CButton,
  CRow,
  CSmartTable,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
  CModalFooter,
  CTableRow,
  CTableDataCell,
  CTableBody,
  CTableHeaderCell,
  CModalHeader,
  CModal,
  CModalBody,
  CTable,
  CTableHead,
  CForm,
  CFormLabel,
  CFormInput,
} from '@coreui/react-pro'
import { toast } from 'react-toastify'

import moment from 'moment'
import ToastComponent from 'src/components/common/TaostComponent.js'
import UserService from 'src/service/UserService'
import CommonService from 'src/service/CommonService'
import EmailQuotaService from 'src/service/EmailQuotaService'
const AdminEmailUsers = () => {
  const [loading, setLoading] = useState()
  const [activePage, setActivePage] = useState(1)
  const [columnFilter, setColumnFilter] = useState([])
  const [columnSorter, setColumnSorter] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [users, setUsers] = useState([])
  const gameTypeLabels = {
    1: 'Season Game',
    2: 'Tournament Game (For Leagues)',
    3: 'Tournament Game (For Indoor Leagues)',
    4: 'Match Contest',
  }
  const columns = [
    {
      label: 'Hub Name',
      key: 'club_name',
    },
    {
      label: 'Game Name',
      key: 'game_name',
    },
    {
      label: 'Game Type',
      key: 'game_type',
    },
    {
      label: 'Email Quota',
      key: 'email_quota',
    },
    {
      label: 'Email',
      key: 'email',
    },
    { label: 'Status', filter: false, key: 'membership_is_paid' },
    {
      key: 'action',
      label: 'Action',
      filter: false,
      sorter: false,
    },
  ]

  useEffect(() => {
    fetchData(activePage, columnFilter, columnSorter, itemsPerPage)
  }, [activePage, columnFilter, columnSorter, itemsPerPage])

  const fetchData = (activePage, columnFilter, columnSorter, itemsPerPage) => {
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })
    columnSorter &&
      columnSorter.column !== undefined &&
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

    EmailQuotaService.adminEmailUsers(offset, itemsPerPage, activePage, params).then((result) => {
      setUsers(result.data)
      setLoading(false)
    })
  }

  const [visibleModal, setVisibleModal] = useState(false)
  const [selectedUserId, setSelectedUserId] = useState(null)
  const [emailQuota, setEmailQuota] = useState('')

  const showPriceTable = (userId, quotaFromApi) => {
    setSelectedUserId(userId)
    setEmailQuota(quotaFromApi || '') // set API value as initial
    setVisibleModal(true)
  }

  const handleSubmitEmailQuota = () => {
    // API call or logic to save emailQuota
    const formData = {
      gameId: selectedUserId,
      email_quota: emailQuota,
    }
    EmailQuotaService.adminEmailQuotaActivation(formData).then((res) => {
      if (res.status === 200) {
        ToastComponent(res.message, 'success')
        setVisibleModal(false)
        fetchData(activePage, columnFilter, columnSorter, itemsPerPage) // Refresh data
      }
    })
  }
  return (
    <>
      <CRow>
        <CAccordion activeItemKey={1}>
          <CAccordionItem itemKey={1}>
            <CAccordionHeader>
              {' '}
              <strong>Game Admins</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <CSmartTable
                columns={columns}
                columnFilter={{
                  external: true,
                }}
                columnSorter={{
                  external: true,
                }}
                scopedColumns={{
                  membership_is_paid: (item) => {
                    return (
                      <td>
                        {item?.membership_is_paid ? (
                          <CBadge color={'success'}>Paid </CBadge>
                        ) : (
                          <CBadge color={'danger'}>Unpaid</CBadge>
                        )}
                      </td>
                    )
                  },
                  game_type: (item) => {
                    return <td>{gameTypeLabels[item.game_type] || '-'}</td>
                  },
                  email_quota: (item) => {
                    return <td>{item?.email_quota ?? 0}</td>
                  },
                  action: (item) => {
                    return (
                      <>
                        <td>
                          <CButton
                            color="primary"
                            variant="outline"
                            shape="square"
                            size="sm"
                            onClick={() => {
                              showPriceTable(item.game_id, item?.email_quota)
                            }}
                          >
                            Activate
                          </CButton>
                        </td>
                      </>
                    )
                  },
                }}
                items={users?.data}
                itemsPerPage={itemsPerPage}
                itemsPerPageSelect
                loading={loading}
                pagination={{
                  external: true,
                }}
                paginationProps={{
                  activePage: activePage,
                  pages: Math.ceil(users?.total / itemsPerPage) || 1,
                }}
                tableProps={{
                  hover: true,
                  responsive: true,
                }}
                onActivePageChange={(activePage) => setActivePage(activePage)}
                onColumnFilterChange={(filter) => {
                  setActivePage(1)
                  setColumnFilter(filter)
                }}
                onItemsPerPageChange={(itemsPerPage) => {
                  setActivePage(1)
                  setItemsPerPage(itemsPerPage)
                }}
                onSorterChange={(sorter) => setColumnSorter(sorter)}
              />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
      </CRow>

      <CModal
        visible={visibleModal}
        onClose={() => setVisibleModal(false)}
        size="lg"
        backdrop="static"
      >
        <CModalHeader>
          <strong>Email Quota Plan</strong>
        </CModalHeader>
        <CModalBody>
          <div className="mt-3">
            <CForm
              onSubmit={(e) => {
                e.preventDefault()
                handleSubmitEmailQuota()
              }}
            >
              <CFormLabel htmlFor="emailQuota">Email Quota</CFormLabel>
              <CFormInput
                type="number"
                id="emailQuota"
                placeholder="Enter Email Quota"
                value={emailQuota}
                onChange={(e) => setEmailQuota(e.target.value)}
                required
              />
              <div className="mt-3 text-end">
                <CButton color="primary" type="submit">
                  Submit
                </CButton>
              </div>
            </CForm>
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setVisibleModal(false)}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default AdminEmailUsers
